import Grid from '@material-ui/core/Grid';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import TabletLanding from '../../MyComponents/Landing/TabletLanding';
import { ForSchoolsFeaturesTablet } from './SchoolsFeatures/ForSchoolsFeaturesTablet';
import { VIDEO_URLS } from '../../constants';
import RequestOfferButton from '../../MyComponents/RequestOfferButton/RequestOfferButton';

const useStyles = makeStyles(() => ({
    desktopContainer: {
        position: 'relative',
        marginBottom: '-10rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    bottomGreenPaper: {
        background: 'rgba(8, 170, 180, 0.16)',
        borderRadius: '0rem 0rem 2rem 2rem',
        height: '2rem',
        width: '90%',
    },
    loginContainer: {
        background: 'transparent',
        padding: '3rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const ForSchoolsTablet = ({ handleOpen, language }) => {
    const classes = useStyles();

    const setCreateGroupPath = () => {
        window.localStorage.setItem('pathBeforeLogin', '/creategroup');
    };

    let needsBackground = false;

    return (
        <>
            <TabletLanding videoUrl={VIDEO_URLS['schools'][language.toUpperCase()]} needsBackground={needsBackground}>
                <Grid
                    item
                    xs={12}
                    style={{ zIndex: 1, textAlign: 'center', paddingTop: needsBackground ? '2rem' : '0rem' }}
                >
                    <Typography variant="h1">
                        <FormattedMessage
                            id={'redesign.home.forSchools.tagline'}
                            values={{
                                b: (chunks) => (
                                    <b>
                                        <br></br>
                                        {chunks}
                                        <br></br>
                                    </b>
                                ),
                            }}
                        />
                    </Typography>
                </Grid>
                <Grid item xs={12} md={12} className={classes.loginContainer}>
                    <RequestOfferButton />
                </Grid>
            </TabletLanding>
            <div className={classes.desktopContainer}>
                <ForSchoolsFeaturesTablet
                    handleOpen={() => {
                        handleOpen(false);
                        setCreateGroupPath();
                    }}
                />
                <div className={classes.bottomGreenPaper} />
            </div>
        </>
    );
};

export default ForSchoolsTablet;
